import React from 'react'
import styled from 'styled-components'

const StatementStatBarSm = ({result, barColor = "#f58220"}) => {
  return (
    <BarContainer className="statement-stat-bar">
      <ResultBar style={{ width: `${result || 0}%`, backgroundColor: barColor }} />
    </BarContainer>
  )
}

export default StatementStatBarSm;

const BarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 80px;
  height: 12px;
  border-radius: 12px;
  border-radius: 10px;
  background-color: #f4f3f1;
  overflow: hidden;
`;

const ResultBar = styled.div`
  height: 100%;
  border-radius: 12px;
`;


// WEBPACK FOOTER //
// ./src/components/ui/statement-stat-bar-sm.js